import React from 'react';
import { Droplet, Home, Umbrella, BarChart2 } from 'lucide-react';

const Navigation = ({ activeBucket, onNavigationClick }) => {
  const sections = [
    { id: 'personal', label: 'Personal Info', icon: <Home className="w-4 h-4" /> },
    { id: 'indoor', label: 'Indoor Usage', icon: <Droplet className="w-4 h-4" /> },
    { id: 'outdoor', label: 'Outdoor Usage', icon: <Umbrella className="w-4 h-4" /> },
    { id: 'result', label: 'Results', icon: <BarChart2 className="w-4 h-4" /> }
  ];

  // Function to handle navigation clicks with basic validation
  const handleNavClick = (sectionId) => {
    onNavigationClick(sectionId);
  };

  return (
    <nav className="bg-white shadow-md sticky top-0 z-10">
      <div className="container mx-auto px-4">
        <div className="flex justify-center py-4 overflow-x-auto">
          <div className="flex space-x-1 md:space-x-2">
            {sections.map((section, index) => (
              <React.Fragment key={section.id}>
                <button
                  onClick={() => handleNavClick(section.id)}
                  className={`px-3 md:px-4 py-2 rounded-lg transition-colors flex items-center whitespace-nowrap
                    ${activeBucket === section.id
                      ? 'bg-blue-600 text-white'
                      : 'text-gray-600 hover:bg-gray-100'}`}
                >
                  <span className="mr-2">{section.icon}</span>
                  <span className="hidden md:inline">{section.label}</span>
                  <span className="inline md:hidden">{section.label.split(' ')[0]}</span>
                </button>
                {index < sections.length - 1 && (
                  <div className="flex items-center text-gray-300">
                    <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                    </svg>
                  </div>
                )}
              </React.Fragment>
            ))}
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navigation;